<template>
  <el-dialog
    :title="dialogType === 'edit' ? 'Source Update' : 'Source Create'"
    :visible="dialogVisible"
    :close-on-click-modal="false"
    width="65%"
    @close="handleClose"
  >
    <el-form
      label-position="left"
      label-width="170px"
      :model="source"
      :rules="rules"
      ref="baseForm"
      class="grid-form"
    >
      <el-form-item label="SourceName" prop="company">
        <el-input v-model="source.company" clearable filterable placeholder="please select" />
      </el-form-item>
      <el-form-item label="Company Entity" prop="bfiId" required>
        <el-select
          v-model="source.bfiId"
          placeholder="please input"
          filterable
          clearable
          @change="handleCompanyEntity"
        >
          <el-option
            v-for="item in companyBankList"
            :value="item.bfiId"
            :label="item.companyEntity"
            :key="item.bfiId"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="Bank Account Name" prop="bfbId">
        <el-select v-model="source.bfbId" clearable filterable placeholder="please input">
          <el-option
            v-for="item in bankList"
            :value="item.bankId"
            :key="item.bankId"
            :label="item.bankAccountName"
          >
            {{ item.bankAccountName }}
            <el-tag style="margin-left: 5px" v-for="(tag, index) in item.bankTags" :key="index"
              >{{ tag }}
            </el-tag>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="dialogType !== 'new'" label="SignName">
        <el-input v-model="source.signName" />
      </el-form-item>
      <el-form-item v-if="dialogType !== 'new'" label="SyncURL">
        <el-input v-model="source.syncUrl" />
      </el-form-item>
      <el-form-item label="PM" prop="pmId">
        <el-select v-model="source.pmId" filterable @change="handlePmSelectChange">
          <el-option
            v-for="item in pmList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="BD" prop="bdId">
        <el-select v-model="source.bdId" filterable @change="handleBdSelectChange">
          <el-option
            v-for="item in bdList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Email" prop="email">
        <el-input v-model="source.email" />
      </el-form-item>
      <el-form-item label="Weightiness">
        <el-input v-model="source.weightiness" placeholder="0~10" />
        <el-tag type="warning">权重低于等于5每日只测一次单,0表示不测单</el-tag>
      </el-form-item>
      <el-form-item label="Description" prop="description">
        <el-input v-model="source.description" />
      </el-form-item>
      <el-form-item label="TimeZone" prop="timezone">
        <el-input v-model.number="source.timeZone" />
      </el-form-item>
      <el-form-item label="Traffic Type" prop="level">
        <el-select v-model="source.level">
          <el-option
            v-for="item in SourceConstants.trafficTypes"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Traffic Tag:" prop="trafficTag">
        <el-select v-model="source.trafficTag" multiple clearable filterable placeholder="status">
          <el-option
            v-for="item in tagOption"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Payout Type" prop="payoutType">
        <el-select v-model="source.payoutType" placeholder="请选择">
          <el-option
            v-for="item in SourceConstants.payoutType"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="dialogType === 'new'" label="Authorised:" prop="bindAccountId">
        <el-select v-model="source.bindAccountId" clearable filterable>
          <el-option
            v-for="item in bindAccountList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSubmit">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import { getBindAccountListApi } from 'api/account';
  import { getAllTags } from 'api/affiliate/tag';
  import { insertSource, updateSource } from 'api/source/overall';
  import { RoleName, SourceConstants } from '@/assets/js/constants';
  import { getUserListByRole } from 'api/user';
  import { validateEmail } from 'utils/validator';
  import { getCompanyBankAdvOption } from 'api/common/companyInfo';

  export default {
    name: 'SourceBaseForm',
    computed: {
      SourceConstants() {
        return SourceConstants;
      },
    },
    props: {
      dialogType: {
        type: String,
        default: 'new',
      },
      dialogVisible: {
        type: Boolean,
        default: false,
      },
      updateData: {
        type: Object,
        default: () => {
          return {};
        },
      },
    },
    data() {
      return {
        source: {},
        tagOption: [],
        bindAccountList: [],
        bdList: [],
        pmList: [],
        formLoading: false,
        companyBankList: [],
        bankList: [],
        rules: {
          email: [{ validator: validateEmail, trigger: 'blur', required: true }],
          company: [{ trigger: 'blur', required: true }],
          bdId: [{ trigger: 'blur', required: true }],
          pmId: [{ trigger: 'blur', required: true }],
          payoutType: [{ trigger: 'blur', required: true }],
          bindAccountId: [{ trigger: 'blur', required: true }],
          description: [{ trigger: 'blur', required: true }],
          companyName: [{ trigger: 'blur', required: true }],
        },
      };
    },
    watch: {
      updateData: {
        handler(newVal) {
          this.source = Object.assign({}, newVal);
        },
      },
      dialogVisible(newVal) {
        this.bankList.length = 0;
        let temp = this.companyBankList.find(
          (item) => item.bfiId === this.source.bfiId && item.bankList !== undefined
        );
        if (temp && temp.length !== 0) {
          this.bankList = [...temp.bankList];
        }
        if (!newVal) {
          this.$refs.baseForm.resetFields();
        } else {
          if (this.$refs.baseForm) {
            this.$refs.baseForm.clearValidate();
          }
        }
      },
    },
    mounted() {
      this.$store.dispatch('source/getSourceIdsList');
      this.getTagList();
      this.getPmList();
      this.getBdList();
      this.getBindAccountList();
      this.getCompanyBank();
    },
    methods: {
      handleCompanyEntity(value) {
        if (value === '') {
          return;
        }
        this.bankList.length = 0;
        this.source.bfbId = null;
        let temp = this.companyBankList.find(
          (item) => item.bfiId === value && item.bankList !== undefined
        );
        if (temp && temp.length !== 0) {
          this.bankList = [...temp.bankList];
        }
      },
      async handleSubmit() {
        await this.$refs.baseForm.validate((valid) => {
          if (valid) {
            const params = { ...this.source };
            if (params.trafficTag) {
              params.trafficTag = params.trafficTag?.join(',');
            }
            if (this.dialogType === 'new') {
              try {
                const pattern = /^(([0-9](\.\d{2})?)|10|10.0)$/;
                if (!pattern.test(this.source.weightiness)) {
                  this.$message.error('Weightiness只限于0到10~');
                  return;
                }

                insertSource(params).then(() => {
                  this.$message({
                    message: 'Add Success',
                    type: 'success',
                  });
                  this.$emit('refresh-list');
                  this.handleClose();
                });
              } catch (error) {
                console.log(error);
              }
            } else {
              updateSource(params).then(() => {
                this.$message({
                  message: 'Update Success',
                  type: 'success',
                });
                this.$emit('refresh-list');
                this.handleClose();
              });
            }
            this.formLoading = false;
          } else {
            return false;
          }
        });
      },
      getBindAccountList() {
        getBindAccountListApi()
          .then((resp) => {
            this.bindAccountList = resp.result?.map((item) => ({
              label: item.uname,
              value: item.id,
            }));
          })
          .catch(() => {
            this.bindAccountList = [];
          });
      },
      getCompanyBank() {
        getCompanyBankAdvOption().then((res) => {
          if (res.result) {
            this.companyBankList = res.result;
          }
        });
      },
      getTagList() {
        getAllTags('offer')
          .then((resp) => {
            this.tagOption = resp.result?.map((item) => ({
              label: item.trafficTag,
              value: item.trafficTag,
            }));
          })
          .catch(() => {
            this.tagOption = [];
          });
      },
      getPmList() {
        getUserListByRole(RoleName.PM)
          .then((response) => {
            if (response.result) {
              this.pmList = response.result.map((item) => ({
                label: item.uname,
                value: item.id,
              }));
            }
          })
          .catch(() => {});
      },
      getBdList() {
        getUserListByRole(RoleName.BD)
          .then((response) => {
            if (response.result) {
              this.bdList = response.result.map((item) => ({
                label: item.uname,
                value: item.id,
              }));
            }
          })
          .catch(() => {});
      },
      handleBdSelectChange(value) {
        const option = this.bdList.find((item) => item.value === value);
        if (option) {
          this.source.bdName = option.label;
        }
      },
      handlePmSelectChange(value) {
        const option = this.pmList.find((item) => item.value === value);
        if (option) {
          this.source.pmName = option.label;
        }
      },
      handleClose() {
        this.$emit('update:dialogVisible', false);
      },
    },
  };
</script>

<style scoped lang="scss"></style>
